import React from 'react';

import WizardFormView from './WizardForm.view';

const WizardForm = ({ children, initialValues, header }: any) => {
  /**
   * Keeps current page number
   */
  const [page, setPage] = React.useState(0);

  /**
   * Keeps wizard steps number
   */
  const numberOfSteps = Math.max(0, React.Children.count(children) - 1);

  /**
   * Trigger display previous page
   */
  const handlePrev = () => {
    setPage(Math.max(0, page - 1));
  };

  /**
   * Trigger display next page
   */
  const handleNext = () => {
    setPage(Math.min(numberOfSteps, page + 1));
  };

  /**
   * Keep only Wizard.Page as children
   */
  const wizardPages = React.Children.toArray(children).filter(
    (reactElement) => reactElement.type.displayName === 'WizardForm.Page'
  );
  return (
    <WizardFormView
      page={page}
      header={header}
      handlePrev={handlePrev}
      handleNext={handleNext}
      initialValues={initialValues}
    >
      {wizardPages}
    </WizardFormView>
  );
};

WizardForm.Page = ({ children }) => children;

/**
 * To allow filter out non Steps from render
 */
WizardForm.Page.displayName = 'WizardForm.Page';

export default WizardForm;
